var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('rec-alert',{attrs:{"set-dialog":this.alertDialog},on:{"close":_vm.closeAlert,"cancel":_vm.cancelAlert}}),_c('router-view')],1),_c('progress-bar',{attrs:{"set-loading":this.progress},on:{"showLoading":_vm.showLoading,"hideLoading":_vm.hideLoading}}),_c('CommonDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }